import Button from 'react-bootstrap/Button';
import PropTypes from "prop-types";
import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/**
 * IMPORTANT:
 * - BOTH Max and Min values are isRequired
 * - A function will need to be passed in as it is also isRequired with a single param.
 *   the function will return the value of the input box (number type)
 */

//  TODO: add a persistant value prop, this will help any rerending issues that may occur

class InputPlusAndMinus extends React.Component {
  state = {
    inputBoxValue: 0
  };
  componentDidMount() {
    /**
     * use the default prop to stop any rerendering
     */
    // if there is no default then set it to the minimum value
    const inputBoxValue = this.props.defaultValue || this.props.min;
    this.setState({
      inputBoxValue
    });
  }
  // componentDidUpdate(prevProps, prevState) {
  //   // ensure the inputBoxValue has a number inside of it and
  //   // that it has changed since the last update
  //   if (parseInt(this.state.inputBoxValue, 10)) {
  //     if (prevState.inputBoxValue !== this.state.inputBoxValue) {
  //       this.props.updateFunction(this.state.inputBoxValue);
  //     }
  //   }
  // }

  increaseCount = max => {
    let { inputBoxValue } = { ...this.state };
    inputBoxValue < max ? inputBoxValue++ : (inputBoxValue = max);
    this.setState({
      inputBoxValue
    });
    this.props.updateFunction(inputBoxValue);
  };

  decreaseCount = min => {
    const { inputBoxValue } = { ...this.state };
    let minusValue = inputBoxValue;
    if (inputBoxValue > min) {
      minusValue--;
    } else {
      minusValue = min;
    }
    this.setState({
      inputBoxValue: minusValue
    });
    this.props.updateFunction(minusValue);
  };

  handleUpdate = e => {
    this.setState({
      inputBoxValue: e.target.value
    });
  };
  updateValueFromInput = e => {
    /**
     * - Does the length of the value inside inputBoxValue === 0 ?
     * - is the value a valid number?
     * - is the value within the max min range?
     */
    let { inputBoxValue } = { ...this.state };

    if (isNaN(Number(e.target.value))) {
      inputBoxValue = Number(this.state.inputBoxValue);
    } else {
      if (e.target.value.length === 0 || Number(e.target.value) === 0) {
        inputBoxValue = 0;
      } else if (Number(e.target.value)) {
        if (
          this.inMaxMinRange(e.target.value, this.props.max, this.props.min)
        ) {
          inputBoxValue = Number(e.target.value);
        } else {
          inputBoxValue =
            Number(e.target.value) < this.props.min
              ? this.props.min
              : this.props.max;
        }
      }
    }
    this.setState({
      inputBoxValue
    });
    this.props.updateFunction(inputBoxValue);
  };

  // if the number is above the minimum and below the maximum then return true
  inMaxMinRange = (value, max, min) => value <= max && value >= min;

  render() {
    // **
    //  * add users will add additional users on click
    //  *
    //  * It will look to see if the text box is empty, if
    //  * it is the onBlur will handle this
    //  *
    //  * if the value of the input is NaN then it wont let the user to put it in the box
    //  *
    //  * @param {string} e event object
    //  * @param {string | number} id id to send to the basket to update the users for a package
    //  */

    /**
     * ? What does this component do?
     *  - increase a number on click
     *  - decrease a number on click
     *  - enter a number on types
     *
     * ? What action does it need to take?
     *  - update a number dependant on state
     *  - Call a function provided by props when state changes
     */
    const { min, max } = this.props;
    return (
      <Container className='paper-packages-btn-container' direction="row">
        <Row className='paper-packages-btn-row'>
          <Col xs={4} className='paper-packages-btn-col'>
            <Button
              className="plus-minus-btn"
              variant="fab"
              aria-label="remove packs"
              onClick={e => this.decreaseCount(min)}
              data-testid="minus-button"
            >
              <i className="fa fa-minus"></i>
            </Button>
          </Col>
          <Col xs={4} className='paper-packages-btn-col'>
            <input
              value={this.state.inputBoxValue}
              className="plus-minus-input"
              onChange={e => this.handleUpdate(e)}
              onBlur={e => this.updateValueFromInput(e)}
              maxLength={max.toString().length}
              data-testid="input-plus-minus"
              type="number"
            />
          </Col>
          <Col xs={4} className='paper-packages-btn-col'>
            <Button
              className="plus-minus-btn"
              variant="fab"
              aria-label="add packs"
              onClick={e => this.increaseCount(max)}
              data-testid="plus-button"
            >
              <i className="fa fa-plus"></i>
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

InputPlusAndMinus.propTypes = {
  defaultValue: PropTypes.number,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  updateFunction: PropTypes.func.isRequired
};

export default InputPlusAndMinus;
